import React from 'react';
import { SubmitTicketTemplate } from 'themes/components';

class SubmitTicket extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <SubmitTicketTemplate {...this.props}/>;
	}
}

export default SubmitTicket;
